export const PRIMARY_COMPANIES = {
  NORWEX: 'Norwex',
  PAMPERED_CHEF: 'Pampered Chef',
  CRUNCHI: 'Crunchi',
  PARK_LANE: 'Park Lane',
  THIRTY_ONE: 'Thirty-One',
  SIPOLOGY: 'Sipology',
  COLOR_STREET: 'Color Street',
};
